module.exports = __webpack_public_path__ + "static/img/物联网模块.049c8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/product-article/物联网模块.png
// module id = 657
// module chunks = 1